module.exports = __webpack_public_path__ + "static/media/bg.c7634981.svg";